import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { borderRadius, dashboardCardDimensions } from '../../../assets/styles/themes/tokens';

const CardSkeleton: React.FC = () => {
  return (
    <Box 
      sx={{
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
      }}>
      <Skeleton
        sx={{ borderRadius: borderRadius.lg }}    
        variant='rectangular' 
        width={dashboardCardDimensions.width} 
        height={dashboardCardDimensions.height}
      />
    </Box>
  );
};

export default CardSkeleton;

